export const css = {
    oneaction: '_2oDpGQ6n',
    ' _key': 'afcpe-theme/afcpe/quiz-widgets/singlestep'
};
export default css;
